/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Signal} from '@gongxigames/framework/core';
import {FC, $Container, $RichText, $Sprite} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {$Checkbox} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Checkbox';
import {$Popup} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Popup';
import {Circle} from 'pixi.js';

type TurboModePopupPops = {showPopup: Signal<boolean>; turboCheckbox: Signal<boolean>;};

export const $TurboModePopup: FC<TurboModePopupPops> = ({showPopup, turboCheckbox}) => {
    return <$Container name='portrait'>
        <$Popup
            responsiveConfig={{
                updateHeight: true,
                updateWidth: true,
                box: {x: '50%', y: '50%', width: '660px', height: '610px'},
                translate: {x: '-50%', y: '-375px'}
            }}
            show={showPopup}
            onClose={() => {
                showPopup.value = false;
                turboCheckbox.value = false;
            }}
        >
            <$Button
                hitArea={new Circle(0, 0, 188/2)}
                name='tick_btn'
                scale={0.72}
                responsive={{
                    box: {x: '50%', y: '100%'},
                    translate: { y: '-96px'}
                }}
                action={() => {
                    showPopup.value = false;
                }}
            />

            <$Checkbox
                value={turboCheckbox}
                position={[161, 371]}
                action={(isChecked: boolean)=> {
                    turboCheckbox.value = isChecked;
                }}
            />
            <$RichText style={{fill: 0xFFAE00, fontFamily: 'Exo Medium', fontSize: 52, align: 'center'}}
                responsive={{
                    box: {x: '50%', y: '18px'},
                }}
                maxWidth={450}
                localeID='turboSpin'/>
            <$RichText style={{fill: 0xffffff, fontFamily: 'Exo Medium', fontSize: 34}} position={[39, 123]}
                localeID='turboModeHint1'
                maxWidth={600}
            />
            <$RichText style={{fill: 0xffffff, fontFamily: 'Exo Medium', fontSize: 25}} position={[41, 230]}
                maxWidth={450}
                localeID='turboModeHint2'/>
            <$Sprite
                position={[540, 258]}
                anchor={0.5}
                scale={0.5}
                texture='turbo_btn_off_normal_sys_ui'
            />
            <$RichText style={{fill: 0xffffff, fontFamily: 'Exo Medium', fontSize: 40}} position={[250, 349]}
                maxWidth={380}
                localeID='turboSpin'/>
        </$Popup>
    </$Container>;

};